// Shapes for the ingest pipeline (docs/15-ingest-architecture.md).
// Every read value carries its confidence and where it came from, so the
// review UI can flag what deserves a human eye. Serials are ALWAYS confirmed
// by a person regardless of confidence — that gate is a security control
// (docs/14, ADR 0006), not a convenience.

export type FieldSource = "text" | "ocr" | "rule";

export interface Rect { page: number; x: number; y: number; w: number; h: number }

export interface Field<T> {
  value: T;
  confidence: number;      // 0..1
  source: FieldSource;
  rect?: Rect;
}

export interface Token {
  str: string;
  page: number;
  x: number;                // left, in viewport units, origin top-left
  y: number;                // top
  w: number;
  h: number;
}

export interface Line {
  page: number;
  y: number;
  text: string;             // column gaps preserved as double spaces
  tokens: Token[];
}

export interface InvoiceItem {
  qty: Field<number>;
  model: Field<string>;
  serial: Field<string | null>;
  unitPrice: Field<number>;
}

export interface ParsedInvoice {
  kind: "text";
  maker: Field<string>;
  invoiceNo: Field<string>;
  invoiceDate: Field<string>;      // ISO yyyy-mm-dd when parseable
  total: Field<number> | null;
  subtotal: number | null;
  arithmeticOk: boolean;           // sum(qty*unit) matched the printed subtotal/total
  items: InvoiceItem[];
  linesText: string;               // reconstructed text, for the specimen pane
  warnings: string[];
  ocr: boolean;                    // true when the read came from on-device OCR
}

export interface ScannedResult {
  kind: "scanned";
  pages: number;
  note: string;
}

export interface UnsupportedResult {
  kind: "unsupported";
  reason: string;
}

export type IngestResult = ParsedInvoice | ScannedResult | UnsupportedResult;

export function field<T>(value: T, confidence: number, source: FieldSource, rect?: Rect): Field<T> {
  return { value, confidence, source, rect };
}
